export class InsuranceUser {
  firstName = "";
  lastName = "";
}
